import { useCallback } from "react";
import { getVersionPlan } from "../../../api/content/versionsApi";
import type { VersionPlan } from "../../../api/content/versionDecoders";
import { useLoad, type LoadHandle } from "../../../shared/loading/useLoad";

const NO_PLAN: Promise<VersionPlan | null> = Promise.resolve(null);

/**
 * What the change set proposes for each label, read again whenever its head moves.
 * `changeSetId` `null` reads nothing, for a form that isn't merging.
 */
export function useVersionPlan(changeSetId: string | null, head: string): LoadHandle<VersionPlan | null> {
  const load = useCallback(
    // `head` is read so a new head loads a new plan; the server plans the current head.
    (signal: AbortSignal) => (changeSetId === null || head === "" ? NO_PLAN : getVersionPlan(changeSetId, signal)),
    [changeSetId, head],
  );
  return useLoad(load);
}
